import type { ReactNode } from 'react'

export function LabeledValue({ children, label }: { children: ReactNode; label: string }) {
  return (
    <div>
      <div className="mb-1 font-medium text-heading-foreground text-sm">{label}</div>
      <div className="text-body-foreground">{children}</div>
    </div>
  )
}
